<template lang="pug">
  nav(class="bg-app-navbar")
    div
      ul
        li
          router-link(to='/') Home
        li
          router-link(to='/about') About
        li
          router-link(to='/contact-us') Contact Us
</template>

<script>
export default {
  name: "NavBar"
};
</script>
